
export { openPDFFromUrl } from "/builds/dd3tech/wiggot/wiggot-web/packages/utils/src/download-pdf.ts"